module.exports = __webpack_public_path__ + "static/media/ic_stock.1e384464.svg";